document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('[data-policies-section]');
  if (!section) return;

  section.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-accordion-trigger]');
    if (!trigger) return;

    const isOpen = trigger.classList.contains('is-open');
    const content = trigger.nextElementSibling;
    if (!content) return;

    content.style.setProperty('--accordion-height', `${content.scrollHeight}px`);

    trigger.classList.toggle('is-open', !isOpen);
    content.classList.toggle('is-open', !isOpen);
  });
});
